// @flow
/**
 * Created by Mike Chung on 2/9/18.
 */

import type {
    SsoUserActivateUserFailedAction,
    SsoUserActivateUserStartAction,
    SsoUserActivateUserSuccessAction,
    SsoUserResendActivationEmailFailedAction,
    SsoUserResendActivationEmailStartAction,
    SsoUserResendActivationEmailSuccessAction,
    SsoUserSendForgotPasswordEmailFailedAction,
    SsoUserSendForgotPasswordEmailStartAction,
    SsoUserSendForgotPasswordEmailSuccessAction,
    SsoUserThunkAction
} from "../ssoUserAction";
import {activateUser, resendActivationEmail, sendForgotPasswordEmail} from "../../../dao/ssoUserDao";
import type {Caller} from "../../../components/QueryPage";
import type {StoreState} from "../../../reducers/combinedReducers";

function ssoUserSendForgotPasswordStartAction(ssoUid: string): SsoUserSendForgotPasswordEmailStartAction {
    return {
        type: "sso/SEND_FP_EMAIL_START_ACTION",
        ssoUid: "" + ssoUid
    };
}

function ssoUserSendForgotPasswordSuccessAction(ssoUid: string): SsoUserSendForgotPasswordEmailSuccessAction {
    return {
        type: "sso/SEND_FP_EMAIL_SUCCESS_ACTION",
        ssoUid: "" + ssoUid
    }
}

function ssoUserSendForgotPasswordFailedAction(error: any, ssoUid: string): SsoUserSendForgotPasswordEmailFailedAction {
    return {
        type: "sso/SEND_FP_EMAIL_FAILED_ACTION",
        error: Object.assign({}, error),
        ssoUid: "" + ssoUid
    }
}

export function ssoUserSendForgotPasswordAction(ssoUid: string, caller: Caller): SsoUserThunkAction {

    return async (dispatch, getState: ?() => StoreState) => {

        try {


            if (getState) {

                dispatch(ssoUserSendForgotPasswordStartAction(ssoUid));
                await sendForgotPasswordEmail(ssoUid, caller, getState().loginUser.jwt);
                dispatch(ssoUserSendForgotPasswordSuccessAction(ssoUid));
            } else {
                throw new Error("Unexpected Error");
            }
        } catch (e) {
            dispatch(ssoUserSendForgotPasswordFailedAction(e, ssoUid));
        }

    };
}

function ssoUserResendActivationStartAction(ssoUid: string): SsoUserResendActivationEmailStartAction {
    return {
        type: "sso/RESEND_EMAIL_START_ACTION",
        ssoUid: "" + ssoUid
    };
}

function ssoUserResendActivationSuccessAction(ssoUid: string): SsoUserResendActivationEmailSuccessAction {
    return {
        type: "sso/RESEND_EMAIL_SUCCESS_ACTION",
        ssoUid: "" + ssoUid
    }
}

function ssoUserResendActivationFailedAction(error: any, ssoUid: string): SsoUserResendActivationEmailFailedAction {
    return {
        type: "sso/RESEND_EMAIL_FAILED_ACTION",
        error: Object.assign({}, error),
        ssoUid: "" + ssoUid
    }
}

export function ssoUserResendActivationAction(ssoUid: string, caller: Caller): SsoUserThunkAction {

    return async (dispatch, getState: ?() => StoreState) => {

        try {

            if (getState) {

                dispatch(ssoUserResendActivationStartAction(ssoUid));
                await resendActivationEmail(ssoUid, caller, getState().loginUser.jwt);
                dispatch(ssoUserResendActivationSuccessAction(ssoUid));
            } else {
                throw new Error("Unexpected Error");
            }
        } catch (e) {

            dispatch(ssoUserResendActivationFailedAction(e, ssoUid));
        }

    };
}


function ssoUserActivateUserStartAction(ssoUid: string): SsoUserActivateUserStartAction {
    return {
        type: "sso/ACTIVATE_USER_START_ACTION",
        ssoUid: "" + ssoUid
    };
}

function ssoUserActivateUserSuccessAction(ssoUid: string): SsoUserActivateUserSuccessAction {
    return {
        type: "sso/ACTIVATE_USER_SUCCESS_ACTION",
        ssoUid: "" + ssoUid
    }
}

function ssoUserActivateUserFailedAction(error: any, ssoUid: string): SsoUserActivateUserFailedAction {
    return {
        type: "sso/ACTIVATE_USER_FAILED_ACTION",
        error: Object.assign({}, error),
        ssoUid: "" + ssoUid
    }
}

export function ssoUserActivateUserAction(ssoUid: string, caller: Caller): SsoUserThunkAction {

    return async (dispatch, getState: ?() => StoreState) => {

        try {

            if (getState) {

                dispatch(ssoUserActivateUserStartAction(ssoUid));
                await activateUser(ssoUid, caller, getState().loginUser.jwt);
                dispatch(ssoUserActivateUserSuccessAction(ssoUid));
            } else {
                throw new Error("Unexpected Error");
            }
        } catch (e) {

            console.log(e);
            dispatch(ssoUserActivateUserFailedAction(e, ssoUid));
        }

    };
}


// WEBPACK FOOTER //
// ./src/actions/sso/creators/ssoUserActionCreator.js